/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogStatus from 'layout/dialog/DialogStatus';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import Button from 'components/common/Button';

export default function RemoveUserConfirmDialog({ dialog, toggleDialog, onSubmit }) {
  const { t } = useTranslation();

  return (
    <Dialog data-testid="delete-user-confirm-dialog" open={dialog.open} fullWidth maxWidth="md">
      <DialogTitle>
        <>
          <DialogStatus variant="warning" />
          <Typography component="h3" variant="h3">
            {t('user.management.delete-account.dialog.title')}
          </Typography>
        </>
      </DialogTitle>
      <DialogContent>{t('user.management.delete-account.dialog.description')}</DialogContent>
      <DialogActions>
        <Button data-testid="cancel-action" color="default" onClick={() => toggleDialog(false)}>
          {t('actions.cancel')}
        </Button>
        <Button data-testid="delete-user-btn" color="primary" onClick={() => onSubmit()}>
          {t('user.management.delete-account.button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
